import { useEffect, type RefObject } from 'react';

export function useSmoothScrollToCurrentMonth(
  scrollRef: RefObject<HTMLDivElement | null>,
  labels: string[],
  itemPx: number,
  duration = 1600,
) {
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const targetLeft = Math.max(labels.length - 1, 0) * itemPx;

    requestAnimationFrame(() => {
      const el = scrollRef.current;
      if (!el) return;

      const start = el.scrollLeft;
      const delta = targetLeft - start;
      if (Math.abs(delta) < 1) return;

      let startTime: number | null = null;

      const step = (now: number) => {
        if (startTime === null) startTime = now;
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.scrollLeft = start + delta * eased;
        if (progress < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    });
  }, [scrollRef, labels, itemPx, duration]);
}
